import {
    GET_ALL_RESTAURANTS,
    ADD_RESTAURANT,
    UPDATE_RESTAURANT,
    DELETE_RESTAURANT,
    GET_REGIONS,
} from "./restaurant.actionsTypes";

const updateRestaurant = (item, action) => {
    const id = action.id,
        restaurant = action.restaurant;
    if (id === item._id || restaurant._id === item._id) {
        if (item.name !== restaurant.name) {
            item.name = restaurant.name;
        }
        if (restaurant.restaurantId) {
            item.restaurantId = restaurant.restaurantId;
        }
        if (restaurant.legalPersonName) {
            item.legalPersonName = restaurant.legalPersonName;
        }
        if (restaurant.taxpayerIdentificationNumber) {
            item.taxpayerIdentificationNumber =
                restaurant.taxpayerIdentificationNumber;
        }
        if (restaurant.accountNumber) {
            item.accountNumber = restaurant.accountNumber;
        }
        if (restaurant.cooperationType) {
            item.cooperationType = restaurant.cooperationType;
        }

        if (restaurant.customerPercentage) {
            item.customerPercentage = restaurant.customerPercentage;
        }
        if (restaurant.restaurantPercentage) {
            item.restaurantPercentage = restaurant.restaurantPercentage;
        }

        item.notificationEmails = restaurant.notificationEmails ?? item.notificationEmails;
        item.telegramChannelId = restaurant.telegramChannelId ?? item.telegramChannelId;

        if (restaurant.hasOwnProperty("restaurantInformation")) {
            item.restaurantInformation = restaurant.restaurantInformation;
        }
        if (restaurant.hasOwnProperty("branches")) {
            item.branches = restaurant.branches;
        }
        if (restaurant.hasOwnProperty("type")) {
            item.type = restaurant.type;
        }
        if (restaurant.hasOwnProperty("deleted")) {
            item.deleted = restaurant.deleted;
        }
        if (restaurant.hasOwnProperty("applicableDeliveryTime")) {
            item.applicableDeliveryTime = restaurant.applicableDeliveryTime;
        }
        if (restaurant.hasOwnProperty("specialHintType")) {
            item.specialHintType = restaurant.specialHintType;
        }
        if (restaurant.hasOwnProperty("nameRu")) {
            item.nameRu = restaurant.nameRu;
        }

        if (restaurant.hasOwnProperty("nameEn")) {
            item.nameEn = restaurant.nameEn;
        }

        if (restaurant.hasOwnProperty("autoSendToPartner")) {
            item.autoSendToPartner = restaurant.autoSendToPartner;
        }
        if (restaurant.hasOwnProperty("isTransactionType")) {
            item.isTransactionType = restaurant.isTransactionType;
        }
        if (restaurant.hasOwnProperty("sendMail")) {
            item.sendMail = restaurant.sendMail;
        }
        if (restaurant.hasOwnProperty("email")) {
            item.email = restaurant.email;
            if (item.email === "") {
                item.sendMail = false;
            }
        }
        if (restaurant.hasOwnProperty("company")) {
            item.company = restaurant.company;
        }

        if (restaurant.hasOwnProperty("b2bHintType")) {
            item.b2bHintType = restaurant.b2bHintType;
        }

        if (restaurant.hasOwnProperty("partnerLegalAddress")) {
            item.partnerLegalAddress = restaurant.partnerLegalAddress;
        }

        if (restaurant.hasOwnProperty("directorFullName")) {
            item.directorFullName = restaurant.directorFullName;
        }

        if (restaurant.hasOwnProperty("bankName")) {
            item.bankName = restaurant.bankName;
        }

        if (restaurant.hasOwnProperty("aahSaler")) {
            item.aahSaler = restaurant.aahSaler;
        }
        if (restaurant.hasOwnProperty("specialHintType")) {
            item.specialHintType = restaurant.specialHintType;
        }

        if (restaurant.hasOwnProperty("passportRequired")) {
            item.passportRequired = restaurant.passportRequired;
        }
        if (restaurant.hasOwnProperty("invoiceIssuanceType")) {
            item.invoiceIssuanceType = restaurant.invoiceIssuanceType;
        }
        if (restaurant.hasOwnProperty("taxRegime")) {
            item.taxRegime = restaurant.taxRegime;
        }
        if (restaurant.hasOwnProperty("crn")) {
            item.crn = restaurant.crn;
        }
        if (restaurant.hasOwnProperty("sn")) {
            item.sn = restaurant.sn;
        }
        if (restaurant.hasOwnProperty("dep")) {
            item.dep = restaurant.dep;
        }
        if (restaurant.hasOwnProperty("cashierId")) {
            item.cashierId = restaurant.cashierId;
        }
        if (restaurant.hasOwnProperty("hasCertificate")) {
            item.hasCertificate = restaurant.hasCertificate;
        }
    }
    return item;
};

export default function restaurants(state = [], action) {
    let newState = Object.assign([], state);
    switch (action.type) {
        case GET_ALL_RESTAURANTS:
            let restaurants = Object.assign([], action.restaurants);
            return restaurants;
        case ADD_RESTAURANT:
            newState = [action.restaurant, ...newState];
            return newState;
        case UPDATE_RESTAURANT:
            return newState.map((item) => {
                return updateRestaurant(item, action);
            });
        case DELETE_RESTAURANT:
            return newState.map((item) => {
                return updateRestaurant(item, action);
            });
        default:
            return newState;
    }
}
